export default {
  env:process.env.NODE_ENV || 'development',
  app:'descriptive.assesment',
  serviceUrl: 'http://167.86.108.192:20000/',
  authServiceUrl: 'https://auth-api.ipplos.com/',
  dataPerPage:40,
  assetsBaseUrl:'http://167.86.108.192:20000/public/',
  tempUploadFolder:'temp',
  googleMapsAPIKey:'AIzaSyD0HJyJQyDCnvAM1Ivz6n4FcEi1wZkTKkM',
  googleMapsDefaultView:{
    mapCenter: {
      lat: 37.9761972226037,
      lng: 23.734194444418
    },
    zoom:7
  },
  widgetAreaBounds:{
    left:0,
    top:60
  },
};
  